"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTypes = exports.OperatorByFieldType = exports.TimestampOperators = exports.DateOperators = exports.NumberOperators = exports.StringOperators = void 0;
// ┌────────────────────────────┐
// │                            │
// │         Operators          │
// │                            │
// └────────────────────────────┘
exports.StringOperators = ['IS_EQUAL_TO', 'IS_NOT_EQUAL_TO', 'IS_IN', 'IS_NOT_IN'];
exports.NumberOperators = [
    'IS_EQUAL_TO',
    'IS_NOT_EQUAL_TO',
    'IS_GREATER_THAN',
    'IS_GREATER_THAN_OR_EQUAL_TO',
    'IS_LESS_THAN',
    'IS_LESS_THAN_OR_EQUAL_TO',
    'IS_BETWEEN',
];
exports.DateOperators = [
    'IS_IN_THE_LAST',
    'IS_EQUAL_TO',
    'IS_BETWEEN',
    'IS_AFTER',
    'IS_ON_OR_AFTER',
    'IS_BEFORE',
    'IS_ON_OR_BEFORE',
];
exports.TimestampOperators = [
    'IS_IN_THE_LAST',
    'IS_EQUAL_TO',
    'IS_BETWEEN',
    'IS_AFTER',
    'IS_ON_OR_AFTER',
    'IS_BEFORE',
    'IS_ON_OR_BEFORE',
];
exports.OperatorByFieldType = {
    STRING: exports.StringOperators,
    NUMBER: exports.NumberOperators,
    DATE: exports.DateOperators,
    TIMESTAMP: exports.TimestampOperators,
    BOOLEAN: ['IS_EQUAL_TO'],
    HAS_NESTED: ['IS_EQUAL_TO'],
};
exports.FieldTypes = ['STRING', 'NUMBER', 'DATE', 'TIMESTAMP', 'BOOLEAN', 'HAS_NESTED'];
//# sourceMappingURL=schema.js.map